import React from 'react';
import { createRoot } from 'react-dom/client';
import { ClientErrorBoundary } from '@shared/components/ClientErrorBoundary';
import {
  initializeClientMonitoring,
  registerGlobalClientErrorHandlers,
} from '@shared/utils/clientMonitoring';
import App from './App';

registerGlobalClientErrorHandlers();
void initializeClientMonitoring();

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <ClientErrorBoundary>
      <App />
    </ClientErrorBoundary>
  </React.StrictMode>
);
